import React from 'react';
import { observer } from 'mobx-react';
import { Link, withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

import currentUser from '../../store/currentUser';
import { VIEWS_TITLES, API_PERMISSIONS } from '../../globals';

const styles = theme => ({
  container: {
    backgroundColor: 'white',
  },
  item: {
    position: 'relative',
    display: 'block',
    padding: theme.spacing(2, 4),
    color: theme.palette.text.disabled,
    textDecoration: 'none',
    '&:hover::after, &$active::after': {
      content: "''",
      position: 'absolute',
      bottom: 0,
      width: `calc(100% - ${theme.spacing(8)}px)`,
      height: 3,
      backgroundColor: theme.palette.primary.main,
    },
    '&[disabled]': {
      pointerEvents: 'none',
    },
  },
  active: {
    '&:not([disabled])': {
      color: theme.palette.text.primary,
    },
  },
});

@withStyles(styles)
@withRouter
@observer
class NavigationSubMenu extends React.Component {
  render() {
    if (!currentUser.is_active) {
      return null;
    }
    const { classes, location } = this.props;

    const re = /^\/([^/]+)\//;
    
    if(location.pathname==='/' || re.exec(location.pathname)===null){
      return null;
    }
    const baseURL = re.exec(location.pathname)[0];
    const tabs = Object.keys(VIEWS_TITLES).filter(e => e.startsWith(baseURL));
    if (tabs.length <= 1) {
      return null;
    }
    return (
      <Grid container direction="row" className={classes.container}>
        {tabs.map(path => {
          const disabled = (
            path in API_PERMISSIONS
              ? !currentUser.can(API_PERMISSIONS[path])
              : false
          );
          return (
            <Grid item key={path}>
              <Link
                to={path}
                className={`${classes.item} ${path === location.pathname ? classes.active : ''}`}
                disabled={disabled}
              >
                <Typography variant="h6" align="center" color="inherit">
                  {VIEWS_TITLES[path]}
                </Typography>
              </Link>
            </Grid>
          );
        })}
      </Grid>
    );
  }
}


export default NavigationSubMenu;
